export type AssistantModelId =
  | 'auto'
  | 'gpt-4o'
  | 'gemini-2.5-pro'
  | 'claude-sonnet-4-5';

export type AssistantModel = {
  id: AssistantModelId;
  label: string;
  provider: 'auto' | 'openai' | 'google' | 'anthropic';
};

export const ASSISTANT_MODELS: AssistantModel[] = [
  { id: 'auto',              label: 'Auto',           provider: 'auto'      },
  { id: 'gpt-4o',            label: 'GPT-4o',         provider: 'openai'    },
  { id: 'gemini-2.5-pro',    label: 'Gemini 2.5 Pro', provider: 'google'    },
  { id: 'claude-sonnet-4-5', label: 'Claude Sonnet 4.5',  provider: 'anthropic' },
];

export const DEFAULT_MODEL_ID: AssistantModelId = 'auto';

export function getModel(id: AssistantModelId): AssistantModel {
  return ASSISTANT_MODELS.find((m) => m.id === id) ?? ASSISTANT_MODELS[0];
}
